import equalHeights from 'global/equalHeights';
import Ajax from 'global/od/Ajax';

const { events } = window.od;

export default class BundleZone {
	constructor(bundleZoneElement) {
		this.element = bundleZoneElement;
		this.placmentId = this.element.getAttribute('data-related-bundle-zone');
		this.mainProd = window.RR_CONFIG.product.sku;

		this.bundleSellZone = '.bundle-sell-zone';
		this.bundleList = `${this.bundleSellZone}__product-list`;
		this.bundleListItem = `${this.bundleSellZone}__product`;
		this.bundlePrice = `${this.bundleSellZone}__total-price`;
		this.altVatPrice = `${this.bundleSellZone}.product-price-panel__price-secondary span`;

		this.compactItem = '.compact-product-item';
		this.compactItemImage = `${this.compactItem}__thumb-image`;
		this.compactItemTitle = `${this.compactItem}__title`;
		this.bundleItem = `${this.bundleSellZone} ${this.compactItem}`;

		this.title = '';
		this.products = [];
		this.trackingLinks = [];
		this.bundleSelects = [];
		this.rrTrackingAttr = 'data-rr-tracking-meta';
	}

	addResults(bundleResult) {
		this.title = bundleResult.title;
		this.products = bundleResult.products;
		this.trackingLinks = bundleResult.clickTrackingURL;
	}

	requestRender() {
		return this.requestTemplate().then(response => {
			this.render(response.data);
			return this;
		});
	}

	requestTemplate() {
		const skuList = Object.keys(this.products);
		const parentSku = window.RR_CONFIG.product.sku;
		const skus = skuList.join(',');
		const bundleUrl = `/ajax/bundle/list?productIds=${parentSku},${skus}`;
		return Ajax({
			method: 'GET',
			url: bundleUrl,
			dataType: 'html',
		});
	}

	render(renderedHtml) {
		this.element.innerHTML = renderedHtml;
		const titleElement = this.element.querySelector(
			'.cross-sell-zone__title-text',
		);

		const obj = this.products;
		Object.entries(obj).forEach(([key, value]) => {
			this.bundleItemLink(key, value);
		});

		if (titleElement) {
			titleElement.innerHTML = this.title;
		}

		equalHeights(this.element);

		events.publish('richRelevanceBundles_Loaded', {
			placmentId: this.placmentId,
			productIds: this.products,
			element: this.element,
		});

		this.bundleLabels();
		this.bundleAddRemove();

		this.form = this.element.querySelector('form');
		this.addThirdPartyTrackingData();
		this.formTracking();

		$('[data-toggle="tooltip"]').tooltip();
	}

	bundleLabels() {
		const checkbox = '.checkbox';
		const productLabels = this.element.querySelectorAll(`${checkbox} label`);
		if (productLabels.length > 0) {
			const added = this.element.querySelector('.added-to-bundle');
			const add = this.element.querySelector('.add-to-bundle');
			const addedText = added.value;
			const addText = add.value;
			const display = 'd-none';
			const labelStatus = 'compact-product-item__status';
			const check = 'checked-label';
			const uncheck = 'unchecked-label';
			const addedLabel = `<span id="${check}" class="${labelStatus}">${addedText}</span>`;
			const addLabel = `<span id="${uncheck}" class="${labelStatus} ${display}">${addText}</span>`;
			const checkInputs = this.element.querySelectorAll(checkbox);

			checkInputs.forEach(checkInput => {
				checkInput.tabIndex = 0;
			});

			productLabels.forEach(productLabel => {
				productLabel.innerHTML = `${addedLabel}${addLabel}`;
			});
		}
	}

	bundleSelect(bundleProduct, select) {
		const bundleLabel = bundleProduct.nextElementSibling;
		const display = 'd-none';
		const check = '#checked-label';
		const uncheck = '#unchecked-label';
		const checkText = bundleLabel.querySelector(check);
		const uncheckText = bundleLabel.querySelector(uncheck);
		const deSelected = 'bundle-sell-zone__product--deselected';

		if (bundleProduct.checked) {
			bundleProduct.checked = false;
			checkText.classList.add(display);
			uncheckText.classList.remove(display);
			select.classList.add(deSelected);
		} else {
			bundleProduct.checked = true;
			checkText.classList.remove(display);
			uncheckText.classList.add(display);
			select.classList.remove(deSelected);
		}
	}

	formTracking() {
		this.form?.addEventListener('submit', ev => {
			ev.preventDefault();
			let trackingMeta = this.form.getAttribute(this.rrTrackingAttr);
			trackingMeta = JSON.parse(trackingMeta);
			const trackingData = trackingMeta.formTrackingData;
			const trackingPromise = [];

			if (trackingData && trackingData.length > 0) {
				trackingData.forEach(url => {
					const currentPromise = Ajax.external({
						method: 'GET',
						url,
					});
					trackingPromise.push(currentPromise);
				});
			}

			Promise.all(trackingPromise).finally(() => {
				this.form.submit();
			});
		});
	}

	addThirdPartyTrackingData() {
		const formTrackingData = [];

		this.bundleSelects.forEach(bundleSelect => {
			if (bundleSelect.querySelector('input[type=checkbox]').checked) {
				const checkedProduct = bundleSelect.closest(this.compactItem);
				const productSku = checkedProduct.getAttribute('data-legacy-sku');
				formTrackingData.push(this.trackingLinks[productSku]);
			}
		});

		this.form?.setAttribute(
			this.rrTrackingAttr,
			JSON.stringify({
				formTrackingData,
			}),
		);
	}

	bundleItemLink(key, value) {
		const sku = `[data-legacy-sku='${key}']`;
		const itemParent = this.element.querySelector(this.bundleList);

		if (itemParent) {
			const itemElement = itemParent.querySelector(sku);
			if (itemElement) {
				const itemThumb = itemElement.querySelector(this.compactItemImage);
				const itemTitle = itemElement.querySelector(this.compactItemTitle);
				itemThumb.href = value;
				itemTitle.href = value;
			}
		}
	}

	updateBundleTotal(prods) {
		return Ajax({
			url: '/ajax/bundle/calculate',
			method: 'POST',
			contentType: 'application/json',
			dataType: 'json',
			data: JSON.stringify(prods),
		});
	}

	bundleUpdate(item) {
		const productArr = [this.mainProd];
		const bundleInput = item.querySelector('input[type=checkbox]');
		const bundleParent = bundleInput.closest(this.bundleList);
		const bundleProducts = bundleParent.querySelectorAll(this.compactItem);
		const bundleDeselected = bundleInput.closest(this.bundleListItem);
		const productSku = 'data-legacy-sku';
		let newFormData = `bundle_${this.mainProd}`;

		this.bundleSelect(bundleInput, bundleDeselected);
		const selectedBundle = item;

		bundleProducts.forEach(bundleProduct => {
			const bundleProductSku = bundleProduct.getAttribute(productSku);
			const bundleItemQty = bundleProduct.previousElementSibling;
			if (
				bundleProduct.querySelector('.checkbox input[type=checkbox]').checked
			) {
				productArr.push(bundleProductSku);
				const bundleData = `_${bundleProductSku}`;
				newFormData = newFormData.concat('', bundleData);
				bundleItemQty.value = '1';
			} else {
				bundleItemQty.value = '0';
			}

			const form = selectedBundle.closest('form');
			const addToCartBtn = form.querySelector('#bundle-add-to-cart');
			form.setAttribute('data-bundle-code', newFormData);
			addToCartBtn.setAttribute('data-bundle-sku', newFormData);
		});

		this.updateBundleTotal(productArr).then(response => {
			const bundleProductParent = selectedBundle.closest(this.bundleSellZone);
			const bundleTotal = bundleProductParent.querySelector(this.bundlePrice);
			const altVatTotal = bundleProductParent.querySelector(this.altVatPrice);
			bundleTotal.innerText = response.data.formattedValue;
			altVatTotal.innerText = response.data.formattedAlternateChannelPrice;
		});

		this.addThirdPartyTrackingData();
	}

	bundleAddRemove() {
		this.bundleSelects = [].slice.call(
			this.element.querySelectorAll(`${this.bundleItem} .checkbox`),
		);

		this.bundleSelects.forEach(bundleSelect => {
			bundleSelect.addEventListener('click', e => {
				e.preventDefault();
				this.bundleUpdate(bundleSelect);
			});
			bundleSelect.addEventListener('keyup', e => {
				if (e.keyCode === 13 || e.which === 13) {
					e.preventDefault();
					this.bundleUpdate(bundleSelect);
				}
			});
		});
	}
}
